import { render, staticRenderFns } from "./KeywordRuleCard.vue?vue&type=template&id=5352f7ba&scoped=true"
import script from "./KeywordRuleCard.vue?vue&type=script&lang=js"
export * from "./KeywordRuleCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordRuleCard.vue?vue&type=style&index=0&id=5352f7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352f7ba",
  null
  
)

export default component.exports